import { graphql } from "@opensea/graphql"
import { itemQuantitiesForQuoteFragment } from "../../../../utils/itemQuantitiesForQuote.fragment"

export const AcceptOfferFlowTimeline_quoteFragment = graphql(
  `
    fragment AcceptOfferFlowTimeline_quote on Quote {
      totalPrice {
        pricePerToken {
          token {
            symbol
          }
        }
      }
      ...itemQuantitiesForQuote
    }
  `,
  [itemQuantitiesForQuoteFragment],
)
